import { IPaginatedREST, IBarrierConfig, IBarrierTypeConfigCreation } from '../types'
import { BOWTIE_BASE_URL, BOWTIE_REST_ENDPOINTS } from '../utils/constants'

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface IBarrierTypeConfigsListFilters {}

export const listBarrierTypeConfigs = async (
    configService = BOWTIE_REST_ENDPOINTS.barrierConfigs
): Promise<IPaginatedREST<IBarrierConfig>> => {
    const qs = new URLSearchParams({}).toString()

    return fetch(`${BOWTIE_BASE_URL}/${configService}/?${qs}`, {
        method: 'GET',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' }
    }).then(async data => {
        let jsonData

        try {
            jsonData = await data.json()
        } catch (err) {
            jsonData = undefined
        }

        if (data.ok) {
            return jsonData
        } else {
            throw new Error(jsonData?.Message ?? jsonData?.error ?? jsonData?.message)
        }
    })
}

export const getBarrierTypeConfig = async (
    id: number,
    configService = BOWTIE_REST_ENDPOINTS.barrierConfigs
): Promise<IBarrierConfig> => {
    if (!id) {
        return undefined
    }

    return fetch(`${BOWTIE_BASE_URL}/${configService}/${id}`, {
        method: 'GET',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' }
    }).then(async data => {
        let jsonData

        try {
            jsonData = await data.json()
        } catch (err) {
            jsonData = undefined
        }

        if (data.ok) {
            return jsonData
        } else {
            throw new Error(jsonData?.Message ?? jsonData?.error ?? jsonData?.message)
        }
    })
}

export const createBarrierTypeConfig = async <COPY extends boolean = false>(
    data: COPY extends true ? { id: number } : IBarrierTypeConfigCreation,
    copy?: COPY,
    configService = BOWTIE_REST_ENDPOINTS.barrierConfigs
): Promise<IBarrierConfig> => {
    return fetch(`${BOWTIE_BASE_URL}/${configService}/${copy ? '?copy=true' : ''}`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
    }).then(async data => {
        let jsonData

        try {
            jsonData = await data.json()
        } catch (err) {
            jsonData = undefined
        }

        if (data.ok) {
            return jsonData
        } else {
            throw new Error(jsonData?.Message ?? jsonData?.error ?? jsonData?.message)
        }
    })
}

export const updateBarrierTypeConfig = async (
    barrierType: IBarrierConfig,
    configService = BOWTIE_REST_ENDPOINTS.barrierConfigs
): Promise<IBarrierConfig> => {
    return fetch(`${BOWTIE_BASE_URL}/${configService}/`, {
        method: 'PATCH',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(barrierType)
    }).then(async data => {
        let jsonData

        try {
            jsonData = await data.json()
        } catch (err) {
            jsonData = undefined
        }

        if (data.ok) {
            return jsonData
        } else {
            throw new Error(jsonData?.Message ?? jsonData?.error ?? jsonData?.message)
        }
    })
}
